import { SomethingWentWrong } from "~/common/assets";
import { DescriptiveErrorLayout } from "~/common/components";

export const InvitationExpiredScreen = () => {
  return (
    <DescriptiveErrorLayout description="The invitation has expired.">
      <img src={SomethingWentWrong} alt="invitation expired" />
    </DescriptiveErrorLayout>
  );
};
